import React from 'react';
import { connect } from 'react-redux'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, BackTop, Breadcrumb, Button } from 'antd';
import { PageHeader } from 'components/header';
import { DoubleRightOutlined, DownloadOutlined } from '@ant-design/icons';

import { isAuth, _setAxios, getParamTable, getParamTempTableFiltering } from '../../../../lib/Helper';

import AuthRedirect from '../../../../components/AuthRedirect'
import JadwalEvaluasi from '../modal/JadwalEvaluasi';
import NilaiEvaluasi from '../modal/NilaiEvaluasi';
import Desktop from './Desktop';
import Mobile from './Mobile';
import SortingTableDesktopWithFilter from '../../../../components/sorting-table/SortingTableDesktopWithFilter';
import SortingTableMobileWithFilter from '../../../../components/sorting-table/SortingTableMobileWithFilter';
import SearchTable from '../../../../components/search-table/SearchTable';
import Filter from '../modal/Filter';
import DownloadFile from '../modal/DownloadFile';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}, {
  value: "nuptk",
  label: "NUPTK",
}, {
  value: "nilai",
  label: "Nilai",
}]

class SupervisiPKG extends React.Component {

  constructor(props) {
    super(props)

    const { privilege } = this.props
    const {tahun_ajaran} = privilege
    const tahunAjaranId = tahun_ajaran?.id || null
    const tkID = privilege.profile ? privilege.profile.tk_id : null

    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {
          gtk_id: tkID,
          tahun_ajaran_id: tahunAjaranId
        },
      },
      jadwalEvaluasi: {
        data: {
          gtk_id: tkID,
          tahun_ajaran_id: tahunAjaranId,
        },
        visible: false
      },
      nilaiEvaluasi: {
        data: {
          gtk_id: tkID,
          tahun_ajaran_id: tahunAjaranId,
        },
        visible: false
      },
      filter: {
        values: {
          gtk_id: tkID,
          tahun_ajaran_id: tahunAjaranId
        },
        visible: false,
      },
      download: {
        visible: false,
      }
    };
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current
      }
    }
    _setAxios("supervisi/penilaian-kinerja-guru/master/table", "POST", params).then(resp => {

      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }

  // FILTER START ------------------------------------------
  setTempTableFilter = (name, value) => {

    let values = this.state.filter.values
    values[name] = value

    this.setState({
      filter: {
        ...this.state.filter,
        values: values
      }
    })

  };

  setTableFilterFromTemp = () => {
    const params = getParamTempTableFiltering(this.state.table, this.state.filter.values)
    this.fetch(params, isMobile ? true : false)
    this.modalFilter(false)
  };

  modalFilter = (visible = false) => {
    this.setState({
      filter: {
        ...this.state.filter,
        visible: visible,
        values: {
          ...this.state.filter.values
        }
      },
    })
  }
  // FILTER END ------------------------------------------

  modalJadwalEvaluasi = (visible = false, data = {}) => {
    this.setState({
      jadwalEvaluasi: {
        data: {
          ...this.state.jadwalEvaluasi.data,
          ...data
        },
        visible: visible
      },
    })
  }

  modalNilaiEvaluasi = (visible = false, data = {}) => {
    this.setState({
      nilaiEvaluasi: {
        data: {
          ...this.state.nilaiEvaluasi.data,
          ...data
        },
        visible: visible
      },
    })
  }

  modalDownload = (visible = false) => {
    this.setState({
      download: {
        visible: visible
      },
    })
  }


  render() {

    const access = this.props.privilege.access["/supervisi/pkg"]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    const action = access.action
    const { table } = this.state;
    const { privilege } = this.props

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
            <Breadcrumb.Item>Supervisi</Breadcrumb.Item>
            <Breadcrumb.Item>Penilaian Kinerja Guru </Breadcrumb.Item>
          </Breadcrumb>}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>

          <PageHeader
            className="site-page-header"
            title="Supervisi PKG"
            subTitle="Penilaian Kinerja Guru"
            extra={[
              action.download ? <Button type='primary' onClick={this.modalDownload.bind(this, true)}><DownloadOutlined /> Instrumen Evaluasi PKG</Button> : ""
            ]}
          />
          <Row gutter={[16, 16]}>
            {/* SEARCH LIST/TABLE */}
            <Col xs={24} sm={18} md={19} >
              <SearchTable table={table} fetch={this.fetch} />
            </Col>

            {/* SORTING LIST/TABLE */}
            <Col xs={24} sm={6} md={5}>
              <SortingTableMobileWithFilter table={table} fetch={this.fetch} sortFields={sortFields} modalFilter={this.modalFilter} />
              <SortingTableDesktopWithFilter table={table} fetch={this.fetch} sortFields={sortFields} modalFilter={this.modalFilter} />
            </Col>

            {/* DATA LIST/TABLE */}
            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalJadwalEvaluasi={this.modalJadwalEvaluasi}
                  modalNilaiEvaluasi={this.modalNilaiEvaluasi}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                  modalJadwalEvaluasi={this.modalJadwalEvaluasi}
                  modalNilaiEvaluasi={this.modalNilaiEvaluasi}
                />
              </MobileView>
            </Col>
          </Row>
        </div>
        {
          this.state.filter.visible ?
            <Filter
              data={this.state.filter.values}
              visible={this.state.filter.visible}
              hideModal={this.modalFilter.bind(this, false)}
              setTempTableFilter={this.setTempTableFilter}
              setTableFilterFromTemp={this.setTableFilterFromTemp}
            /> : ""
        }
        {
          this.state.jadwalEvaluasi.visible ?
            <JadwalEvaluasi
              data={this.state.jadwalEvaluasi.data}
              visible={this.state.jadwalEvaluasi.visible}
              hideModal={this.modalJadwalEvaluasi.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.nilaiEvaluasi.visible ?
            <NilaiEvaluasi
              data={this.state.nilaiEvaluasi.data}
              visible={this.state.nilaiEvaluasi.visible}
              hideModal={this.modalNilaiEvaluasi.bind(this, false)}
              fetchTable={this.fetchTable}
            /> : ""
        }
        {
          this.state.download.visible ?
            <DownloadFile
              data={
                { tahun_ajaran_id: privilege.tahun_ajaran?.id }
              }
              visible={this.state.download.visible}
              hideModal={this.modalDownload.bind(this, false)}
            /> : ""
        }
        <BackTop />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(SupervisiPKG);
